<template lang="pug">
  .h-full.overflow-scroll.scrolling-touch.pt-16.pb-48(class="lg:py-0 lg:absolute lg:inset-0")
    .flex.flex-col.justify-center.items-center.mx-auto(class="w-10/12 lg:h-full")
      .w-full.flex.justify-center.items-center(class="flex-col lg:flex-row")
        .max-w-xl.w-full(ref="canvasContainer" class="lg:mr-12")
          .canvas-container
            .h-0.w-0.overflow-hidden
              v-stage(ref="konva" :config="canvasConfig")
                magrobo(@update="canvasImageToURL")
            img.absolute.inset-0(:src="canvasImageURL")
        .max-w-sm.py-8(class="lg:w-5/12")
          .flex.items-center
            .flex-shrink-0.mr-4.font-bebas.text-2xl.tracking-wider MAGROBO-
            .relative
              .fukidashi MAGROBOに名前を付けよう！
              input.flex-grow.flex-shrink(v-model="name"
                maxlength="8"
                pattern="\d*"
                style="ime-mode:disabled"
                @input="check_Nametype"
                oncopy="return false" onpaste="return false")
              .h-0.mt-1.-mb-1.text-xs 半角のみ。8文字まで。

          .mt-8.flex.items-center
            .mr-auto マグロボ完成率
            .font-bebas.leading-none
              span.text-6xl.inline-block.text-right {{animatedCompletionRate}}
              span.text-2xl.ml-1 %

          hr.my-4
          .flex.justify-around
            .w-24.text-center
              h3 攻撃力
              .font-bebas.text-5xl {{ status.ap }}
            .w-24.text-center
              h3 防御力
              .font-bebas.text-5xl {{ status.dp }}
            .w-24.text-center
              h3 機動力
              .font-bebas.text-5xl {{ status.mb }}
          hr.mb-4

          .action
            template(v-if="completionRate >= 100")
              p.text-bolt.text-sm.font-medium オリジナルMAGROBOは完成した！報告せよ！
              .mt-4
                a(class="w-48 router-link" @click="$emit('share')") MAGROBOを報告
            template(v-else)
              p.text-bolt.text-sm.font-medium MAGROBOは完成していない。探索を継続せよ！
              .mt-4
                router-link(class="w-48 router-link" :to="$store.state ? $store.state.route.from.path : '/map'") 探索を続ける
      .text-center(class="lg:mt-12 mb-12 lg:mb-0 px-8" v-if="completionRate >= 100")
        .button-reset(@click="reset") もう一回挑戦する
          span.inline-block （データがクリアされます）
</template>
<style lang="sass" scoped>
hr
  @apply opacity-25
input
  @apply align-middle border rounded-sm font-bebas uppercase text-center w-full
  background-color: rgba(#000, 0.5)
  font-size: 3.5rem
  line-height: 1
  height: 1.25em
  padding: 0.35em 0.1em 0.25em
.fukidashi
  @apply absolute inset-x-0 mx-2 mb-4 bg-bolt rounded-full px-4 py-2 text-black text-xs text-center leading-none font-medium whitespace-no-wrap
  bottom: 100%
  &::after
    content: ""
    @apply absolute inset-x-0 block w-0 mx-auto
    transform: translateY(6px)
    border-width: 10px
    border-color: theme("colors.bolt") transparent transparent
.canvas-container
  @apply rounded overflow-hidden relative
  background-color: rgba(#000, 0.5)
  box-shadow: 0 0 0 1px rgba(#fff, 0.2)
  &::after
    content: ""
    display: block
    padding-bottom: 100%
.action
  @apply text-center fixed inset-x-0 bottom-0 pb-8 pt-16
  background: linear-gradient(to top, rgba(#000, 0.75) 50%, rgba(#000, 0))
  @screen lg
    @apply relative py-0
    background: none
.button-reset
  @apply text-sm leading-tight text-foul border border-foul p-2 px-4 rounded-full cursor-pointer
  &:hover
    @apply text-white bg-foul
</style>
<script>
const debounce = require("lodash/debounce");
import { mapGetters } from "vuex";
import { TweenMax } from "gsap";
import Magrobo from "@/components/status/magrobo";
export default {
  components: {
    Magrobo
  },
  data() {
    return {
      tweenedCompletionRate: 0,
      canvasImageURL: ""
    };
  },
  computed: {
    ...mapGetters("magrobo", ["completionRate", "status"]),
    name: {
      get() {
        return this.$store.state.magrobo.name;
      },
      set(value) {
        this.$store.dispatch("magrobo/setName", value);
      }
    },
    animatedCompletionRate() {
      return this.tweenedCompletionRate.toFixed(0);
    },
    canvasConfig() {
      return {
        width: 640,
        height: 640
      };
    }
  },
  mounted() {
    this.tweenCompletionRate(this.completionRate);
    this.$nextTick(this.canvasImageToURL);
  },
  watch: {
    completionRate: function(newValue) {
      this.tweenCompletionRate(newValue);
    }
  },
  methods: {
    reset() {
      this.$store.commit("magrobo/reset");
      this.$router.push("/");
    },
    tweenCompletionRate(newValue) {
      TweenMax.to(this.$data, {
        duration: 0.5,
        tweenedCompletionRate: newValue
      });
    },
    check_Nametype(e) {
      let value = e.target.value;
      // eslint-disable-next-line no-control-regex
      const regex = /[^\x01-\x7E]/;
      while (value.match(regex)) {
        value = value.replace(regex, "");
      }
      e.target.value = value;
    },
    canvasImageToURL: debounce(
      function() {
        const konva = this.$refs.konva;
        const stage = konva.getStage();
        stage.draw();
        this.canvasImageURL = stage.toDataURL({
          pixelRatio: 2
        });
      },
      100,
      { maxWait: 500 }
    )
  }
};
</script>
